import React, { useEffect, useMemo, useState, useContext } from 'react';
import { Context } from '../../../context/UserContext';
import moment from 'moment';

import { useDispatch } from 'react-redux';
import { selectComponent, clearSelectedComponent } from '../../../store/reducers/actions'; //updateSelectedComponents

import { useNavigateParams } from '../../../hooks/useNavigateParams';
import { MaterialReactTable } from 'material-react-table';

import { ThemeProvider } from '@mui/material';
/* tema customizado*/
import tableThemeCustom from '../../form/tableThemeCustom';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';

//Import Material React Table Translations
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import CustomDialog from '../../layout/CustomDialog';

import { Box, Button, IconButton, Tooltip } from '@mui/material';
import { Delete, Edit, Print, CurrencyExchange } from '@mui/icons-material';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';

import tratar from '../../../utils/retornaTratamentoURL';

import CrudsAPI from '../../../api/CRUDs';
import * as PlantaoAPI from '../../../api/plantao';
import { relatorios } from '../../../api/relatorios';

/* util */
import { obterPermissoesUsuario, printPdf } from '../../../utils/funcoes';

const Index = () => {
    const [dados, setDados] = useState([]);
    const [token] = useState(localStorage.getItem('token')) || '';
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();
    const urlParams = new URLSearchParams(window.location.search);

    const [optionsTipo, setOptionsTipo] = useState([]);

    const pathname = '/Plantao/CreateOrEdit';
    const ul = urlParams.get('ul') || 12;
    const li = urlParams.get('li') || 41;
    const tipo = urlParams.get('tipo');
    const operacaoUUID = urlParams.get('operacao');
    const uuid = urlParams.get('uuid');
    const btnText = urlParams.get('btnText') || 'Cadastrar';

    const params = new URLSearchParams({
        ul: ul,
        li: li,
        tipo: tipo,
        operacao: operacaoUUID,
        uuid: uuid,
        btnText: btnText,
    });

    const { parametro } = useContext(Context);
    /* Obtem a paginação padrão */
    useEffect(() => {
        if (parametro && parametro.paginacao) {
            setPagination({
                pageIndex: JSON.parse(localStorage.pagination).pageIndex || 0,
                pageSize: JSON.parse(localStorage.pagination).pageSize || parametro.paginacao,
            });
        }
    }, [parametro]);

    //obtem o array de empresas vinculadas ou coloca a empresaId no array
    const empresaIds = (() => {
        const ids = localStorage.getItem('empresaIds');
        if (ids) {
            try {
                const parsedIds = JSON.parse(ids);
                return Array.isArray(parsedIds) && parsedIds.length > 0 ? parsedIds : [localStorage.getItem('empresaId')];
            } catch (error) {
                console.warn('Erro ao analisar empresaIds, usando empresaId:', error);
                return [localStorage.getItem('empresaId')];
            }
        }
        return [localStorage.getItem('empresaId')];
    })();

    //dialog customizado
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedRow, setSelectedRow] = useState({});

    const dispatch = useDispatch();

    //data and fetching state
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isRefetching, setIsRefetching] = useState(false);
    const [rowCount, setRowCount] = useState(0);

    //tratar filtros se vier pela navbar
    if (localStorage.path.replace(/["]/g, '') !== window.location.pathname) {
        tratar.LimparFiltros();
        localStorage.setItem('path', JSON.stringify(window.location.pathname));
    }

    //table state
    const [columnFilterFns, setColumnFiltersMode] = useState(
        localStorage.columnFilterFns.length > 2 ? JSON.parse(localStorage.columnFilterFns) : []
    );

    const [columnFilters, setColumnFilters] = useState(
        localStorage.columnFilters.length > 2 ? JSON.parse(localStorage.columnFilters) : []
    );

    const [globalFilter, setGlobalFilter] = useState(() => {
        const storedFilter = localStorage.getItem('globalFilter');

        if (storedFilter && storedFilter !== 'undefined' && storedFilter.length > 2) {
            try {
                return JSON.parse(storedFilter);
            } catch (e) {
                console.warn('Erro ao parsear globalFilter:', e);
                return ''; // valor padrão
            }
        }
        return ''; // valor padrão
    });

    const [sorting, setSorting] = useState(localStorage.sorting.length > 2 ? JSON.parse(localStorage.sorting) : []);

    const [pagination, setPagination] = useState({
        pageIndex: JSON.parse(localStorage.pagination).pageIndex || 0,
        pageSize: JSON.parse(localStorage.pagination).pageSize || 5,
    });

    //consultas
    const fetchData = async () => {
        if (!dados.length) {
            setIsLoading(true);
        } else {
            setIsRefetching(true);
        }

        try {
            const { data } = await CrudsAPI.plantao.listar(
                pagination.pageIndex * pagination.pageSize,
                pagination.pageSize,
                JSON.stringify(columnFilters ?? []),
                JSON.stringify(columnFilterFns ?? []),
                globalFilter ?? '',
                JSON.stringify(sorting ?? [])
            );

            setDados(data.data);
            setRowCount(data.meta.totalRowCount);
        } catch (error) {
            setIsError(true);
            console.error(error);
            return;
        }
        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
    };

    const consultaTipo = async () => {
        const result = await PlantaoAPI.obterPlantaoTipos(empresaIds);

        const mappedResult = result.map((item) => ({
            label: item.descricao,
            value: item.descricao,
        }));

        setOptionsTipo(mappedResult);
    };
    //funções do dialog
    const handleOpenDialog = (row) => {
        setOpenDialog(true);
        consultaTipo(empresaIds);
        setSelectedRow(row);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleConfirmDialog = async () => {
        // Verifique se há uma linha selecionada
        let msgType = 'success';
        if (selectedRow) {
            // Lógica de confirmação
            try {
                const { data } = await CrudsAPI.plantao.deletar(selectedRow);
                setFlashMessage(data.message, data.type);

                // Após a exclusão, chame a função fetchData() novamente para atualizar as unidades
                fetchData();
            } catch (error) {
                msgType = 'error';
                console.error(error);
                setFlashMessage(error.response.data.message, msgType);
            }
        }
        setOpenDialog(false);
    };

    useEffect(() => {
        if (!token) {
            return navigate('/Auth', { replace: true });
        }

        //funcao para setar localStorage
        localStorage.setItem(
            'pagination',
            JSON.stringify({
                pageIndex: pagination.pageIndex,
                pageSize: pagination.pageSize,
            })
        );
        localStorage.setItem('columnFilterFns', JSON.stringify(columnFilterFns));
        localStorage.setItem('columnFilters', JSON.stringify(columnFilters));
        localStorage.setItem('globalFilter', JSON.stringify(globalFilter));
        localStorage.setItem('sorting', JSON.stringify(sorting));

        //permissões do usuario
        obterPermissoesUsuario(localStorage.getItem('pessoaId'), localStorage.getItem('empresaId'), ul, li);

        consultaTipo();
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, columnFilterFns, columnFilters, globalFilter, pagination.pageIndex, pagination.pageSize, sorting, ul, li]);

    const columns = useMemo(
        () => [
            {
                id: 'plantao',
                header: 'Plantões',
                columns: [
                    {
                        accessorFn: (row) => new Date(row),
                        accessorKey: 'data',
                        header: 'Data',
                        filterVariant: 'date',
                        sortingFn: 'date',
                        columnFilterModeOptions: [
                            'fuzzy',
                            'equals',
                            'between',
                            'betweenInclusive',
                            'greaterThanOrEqualTo',
                            'lessThanOrEqualTo',
                        ],
                        muiTableBodyCellProps: ({ row }) => ({
                            align: 'center',
                            onClick: () => {
                                console.info(row.original);
                            },
                        }),
                        muiTableHeadCellFilterTextFieldProps: {
                            type: 'date',
                            InputLabelProps: {
                                shrink: true,
                            },
                            sx: {
                                minWidth: '200px',
                            },
                        },
                        Cell: ({ renderedCellValue, row }) => {
                            return <span>{moment.utc(row.original.data).format('DD/MM/YYYY')}</span>;
                        },
                    },
                    {
                        accessorKey: 'Equipe.descricao',
                        header: 'Equipe',
                    },
                    {
                        accessorKey: 'plantaoTipo.descricao',
                        header: 'Tipo',
                        filterFn: 'equals',
                        columnFilterModeOptions: ['fuzzy', 'equals', 'notEquals'],
                        filterVariant: 'select',
                        filterSelectOptions: optionsTipo
                            .sort((a, b) => a.label.localeCompare(b.label))
                            .map((option) => ({
                                label: option.label,
                                value: option.label,
                            })),
                    },
                    {
                        accessorFn: (row) => new Date(row),
                        accessorKey: 'inicio',
                        header: 'Início',
                        // Header: ({ column }) => <em>{column.columnDef.header}</em>,
                        // muiFilterTextFieldProps: {
                        //     sx: {
                        //         minWidth: "350px",
                        //     },
                        // },
                        filterVariant: 'date',
                        sortingFn: 'datetime',
                        columnFilterModeOptions: [
                            'fuzzy',
                            'equals',
                            'between',
                            'betweenInclusive',
                            'greaterThanOrEqualTo',
                            'lessThanOrEqualTo',
                        ],
                        muiTableBodyCellProps: ({ row }) => ({
                            align: 'center',
                            onClick: () => {},
                        }),
                        muiTableHeadCellFilterTextFieldProps: {
                            type: 'datetime-local',
                            InputLabelProps: {
                                shrink: true,
                            },
                            sx: {
                                minWidth: '200px',
                            },
                        },
                        Cell: ({ renderedCellValue, row }) => {
                            return <span>{moment(row.original.inicio).format('DD/MM/YYYY HH:mm')}</span>;
                        },
                    },
                    {
                        accessorFn: (row) => new Date(row),
                        accessorKey: 'termino',
                        header: 'Término',
                        // Header: ({ column }) => <em>{column.columnDef.header}</em>,
                        // muiFilterTextFieldProps: {
                        //     sx: {
                        //         minWidth: "350px",
                        //     },
                        // },
                        filterVariant: 'date',
                        sortingFn: 'datetime',
                        columnFilterModeOptions: [
                            'fuzzy',
                            'equals',
                            'between',
                            'betweenInclusive',
                            'greaterThanOrEqualTo',
                            'lessThanOrEqualTo',
                        ],
                        muiTableBodyCellProps: ({ row }) => ({
                            align: 'center',
                            onClick: () => {},
                        }),
                        muiTableHeadCellFilterTextFieldProps: {
                            type: 'datetime-local',
                            InputLabelProps: {
                                shrink: true,
                            },
                            sx: {
                                minWidth: '200px',
                            },
                        },
                        Cell: ({ renderedCellValue, row }) => {
                            return <span>{moment(row.original.termino).format('DD/MM/YYYY HH:mm')}</span>;
                        },
                    },
                    {
                        accessorKey: 'concluido',
                        header: 'Concluído',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        muiTableBodyCellProps: ({ row }) => ({
                            align: 'center',
                            onClick: () => {},
                        }),
                        Cell: ({ row, cell }) => {
                            // Renderiza o checkbox na célula
                            const value = cell.getValue() === '1' || row.original.concluido;
                            return <div style={{ textAlign: 'center' }}>{value ? 'Sim' : 'Não'}</div>;
                        },
                    },
                ],
            },

            //column definitions...
        ],
        [optionsTipo] //getCommonEditTextFieldProps
    );

    /* modo tema */
    const theme = tableThemeCustom();

    //função para imprimir
    const handleImprimir = async (uuids) => {
        const dadosFiltrados = uuids.length > 0 ? dados.filter((value) => uuids.includes(value.uuid)) : dados;

        const urlSearchParams = new URLSearchParams({
            start: `${pagination.pageIndex * pagination.pageSize}`,
            size: `${pagination.pageSize}`,
            filters: JSON.stringify(columnFilters ?? []),
            filtersMode: JSON.stringify(columnFilterFns ?? []),
            globalFilter: globalFilter ?? '',
            sorting: JSON.stringify(sorting ?? []),
            tipo: urlParams.get('tipo') ?? '',
        });

        const response = await PlantaoAPI.imprimirPlantao(urlSearchParams, dadosFiltrados);

        //gera o pdf
        printPdf(response.data);
    };
    return (
        <div>
            <div>
                {openDialog && (
                    <CustomDialog
                        title="Delete Plantão!"
                        content="Você tem certeza?"
                        onClose={handleCloseDialog}
                        onConfirm={handleConfirmDialog}
                    />
                )}
            </div>
            <ThemeProvider theme={theme}>
                <MaterialReactTable
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            muiTableHeadCellProps: {
                                align: 'center',
                            },
                            size: 100,
                        },
                        'mrt-row-numbers': {
                            enableColumnOrdering: true, //turn on some features that are usually off
                            enableResizing: true,
                            muiTableHeadCellProps: {
                                sx: {
                                    fontSize: '1.2rem',
                                },
                            },
                        },
                        'mrt-row-select': {
                            enableColumnActions: true,
                            enableHiding: true,
                            size: 50,
                        },
                    }}
                    enableColumnFilterModes
                    enableGlobalFilterModes
                    //enableColumnResizing
                    enableColumnOrdering
                    enableEditing
                    renderRowActions={({ row, table }) => {
                        const handlePreparaDados = async () => {
                            handleImprimir(row.id);
                        };

                        const handleImprimirCustos = async (obj) => {
                            const caminho = 'custoPlantaoColaboradores';
                            const url = 'custoPlantaoColaboradores';
                            const response = await relatorios(caminho, url, obj);

                            //gera o pdf
                            printPdf(response.data);
                        };

                        return (
                            <Box sx={{ display: 'flex', gap: '1rem' }}>
                                <Tooltip arrow placement="bottom-start" title={'Editar'}>
                                    <span>
                                        {' '}
                                        <IconButton
                                            onClick={() => {
                                                params.set('uuid', row.id);
                                                params.set('btnText', 'Atualizar');
                                                navigate(pathname, params);
                                            }}
                                            disabled={
                                                (row.original.concluido && row.original.assinado) ||
                                                JSON.parse(localStorage.getItem('editar') === false)
                                            }
                                        >
                                            <Edit />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                                <Tooltip arrow placement="top-end" title="Deletar">
                                    <span>
                                        <IconButton
                                            color="error"
                                            onClick={() => handleOpenDialog(row)}
                                            disabled={
                                                (row.original.concluido && row.original.assinado) ||
                                                JSON.parse(localStorage.getItem('cancelar')) === false
                                            }
                                        >
                                            <Delete />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                                <Tooltip arrow placement="bottom-start" title={'Imprimir'}>
                                    <span>
                                        {' '}
                                        <IconButton
                                            onClick={() => {
                                                handlePreparaDados();
                                            }}
                                            disabled={localStorage.getItem('imprimir') === 'true' ? false : true}
                                        >
                                            <Print />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                                <Tooltip arrow placement="bottom-start" title={'Visualizar custos do plantão analítico'}>
                                    <span>
                                        {' '}
                                        <IconButton
                                            onClick={() => {
                                                const obj = { ...row.original, modelo: 'analitico' };
                                                handleImprimirCustos(obj);
                                            }}
                                            disabled={localStorage.getItem('custos') === 'true' ? false : true}
                                        >
                                            <MonetizationOnIcon />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                                <Tooltip arrow placement="top-end" title={'Visualizar custos do plantão sintético'}>
                                    <span>
                                        {' '}
                                        <IconButton
                                            onClick={() => {
                                                const obj = { ...row.original, modelo: 'sintetico' };
                                                handleImprimirCustos(obj);
                                            }}
                                            disabled={localStorage.getItem('custos') === 'true' ? false : true}
                                        >
                                            <CurrencyExchange />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                            </Box>
                        );
                    }}
                    renderTopToolbarCustomActions={({ table }) => {
                        const handlePreparaDados = async () => {
                            dispatch(clearSelectedComponent());
                            const uuids = table.getSelectedRowModel().flatRows.map((row) => row.id);
                            dispatch(selectComponent(uuids));
                            handleImprimir(uuids);
                        };
                        return (
                            <div
                                style={{
                                    display: 'flex',
                                    gap: '8px',
                                }}
                            >
                                <Tooltip arrow placement="top-end" title={`Novo Registro`}>
                                    <div>
                                        {' '}
                                        <Button
                                            color="secondary"
                                            onClick={() => {
                                                params.delete('uuid');
                                                params.set('btnText', 'Cadastrar');
                                                navigate(pathname, params);
                                            }}
                                            variant="contained"
                                            disabled={JSON.parse(localStorage.getItem('incluir')) === false}
                                        >
                                            Novo
                                        </Button>
                                    </div>
                                </Tooltip>
                                <Tooltip arrow placement="top-end" title={`Imprimir plantões selecionados`}>
                                    <div>
                                        <Button
                                            color="info"
                                            variant="contained"
                                            disabled={
                                                JSON.parse(localStorage.getItem('imprimir')) === false ||
                                                (!table.getIsSomeRowsSelected() && !table.getIsAllPageRowsSelected())
                                            }
                                            onClick={handlePreparaDados}
                                        >
                                            Imprimir
                                        </Button>
                                    </div>
                                </Tooltip>
                            </div>
                        );
                    }}
                    columns={columns}
                    data={dados}
                    enableRowSelection
                    getRowId={(row) => row.uuid}
                    manualFiltering
                    manualPagination
                    manualSorting
                    muiToolbarAlertBannerProps={
                        isError
                            ? {
                                  color: 'error',
                                  children: 'Error loading data',
                              }
                            : undefined
                    }
                    onColumnFiltersChange={setColumnFilters}
                    onColumnFilterFnsChange={setColumnFiltersMode}
                    onGlobalFilterChange={setGlobalFilter}
                    onPaginationChange={setPagination}
                    onSortingChange={setSorting}
                    rowCount={rowCount}
                    initialState={{
                        showColumnFilters: true,
                        density: 'compact',
                        //columnPinning: { left: ["mrt-row-select"] },
                    }}
                    state={{
                        columnFilterFns,
                        columnFilters,
                        globalFilter,
                        isLoading,
                        pagination,
                        showAlertBanner: isError,
                        showProgressBars: isRefetching,
                        sorting,
                    }}
                    //positionToolbarDropZone={"top"}
                    positionExpandColumn={'first'}
                    positionActionsColumn={'first'}
                    positionToolbarAlertBanner="bottom"
                    localization={MRT_Localization_PT_BR}
                />
            </ThemeProvider>
        </div>
    );
};
export default Index;
